module.exports = __webpack_public_path__ + "static/gallery-img-20-a6968c8f4d0ffef2a7e15724d31e38ae.jpg";